var _custom_loader = $(".custom-loader"),
    modal_qv_parent = $("#ModalquickView"),
    modal_qv_open = !1,
    modal_qv_content = modal_qv_parent.find(".modal-content");
modal_qv_parent.length &&
    modal_qv_parent
        .on("show.bs.modal", function (e) {
            (modal_qv_open = !0), _custom_loader.show(), modal_qv_content.hide();
            var t = $(e.relatedTarget).filter(":first"),
                i = t.attr("data-value"),
                a = t.closest(".product").find(".description").html(),
                n = window.configureQuickView;
            "function" == typeof n && n(i, a);
        })
        .on("hidden.bs.modal", function () {
            modal_qv_open = !1;
            var e = window.destroyQuickView;
            "function" == typeof e && e();
        });
var quick_view_loader = {
        btn: !1,
        wait: function (e) {
            if (!modal_qv_open) return !1;
            (this.btn = e), e.html(wait_text);
        },
        error: function () {
            if (!modal_qv_open) return !1;
            this.btn.addClass("quickview-error").html(errorhtml_text), this.default_text("quickview-error");
        },
        added: function () {
            if (!modal_qv_open) return !1;
            this.btn.addClass("quickview-added").html(addedhtml_text), this.default_text("quickview-added");
        },
        default_text: function (e) {
            setTimeout(function () {
                quick_view_loader.btn.removeClass(e).html(addtocart_text);
            }, 1e3);
        },
    },
    quickview_swatches = !1;
function configureQuickView(e, t) {
    var i = e.split("/").pop();
    function a(i, a) {      
        var n = modal_qv_parent,
            d = n.find(".product-info"),
            o = n.find(".swatches-container");
        swatchVariantHandler(d, i),
            addToCartHandler.initFormAddToCartButton(i.id, d, o),
            n.find(".title").html(a.title),
          	n.find(".iWishAdd").attr('data-product', a.id);
      		n.find(".iWishAdd").attr('data-pTitle', a.title);      		
            n.find(".viewfullinfo") && n.find(".viewfullinfo").attr("href", e),
            n.find(".qv_vendor") && n.find(".qv_vendor").html(a.vendor);
        var r = n.find(".qv_type");
        r.length && ("" == a.type ? r.parent().hide() : r.html(a.type).parent().show());
        var l = n.find(".product-main-image"),
            s = i.featured_image ? i.featured_image.src : a.featured_image;
        l.children().length ? l.children().first().attr("src", s) : $('<img src="' + s + '" alt="Quick View Image">').appendTo(l);
        var c = n.find(".description").empty();
        c.length && c.html(t);
    }
    Shopify.getProduct(i, function (e) {      
        var t = $(".quickview-swatches-container").length && $(".quickview-swatches-container").attr("data-swatches-design");
        (t = "true" == t ? "viewSelect" : "viewButtons"),
            (quickview_swatches = new SwatchesConstructor(e, {
                contentParent: ".quickview-swatches-container",
                viewDesign: t,
                enableHistoryState: !1,
                callback: a,
                externalImagesObject: texture_obj,
                externalColors: colors_value,
                colorWithBorder: color_with_border,
            })),
            (e = null),
            _custom_loader.hide(),
            modal_qv_content.fadeIn();
    });
}
function destroyQuickView() {
    quickview_swatches && quickview_swatches.destroy(), (quickview_swatches = !1);
    var e = modal_qv_parent;
    e.find(".product-main-image").empty(), e.find(".description").empty(), e.find(".swatches-container").empty(), e.find(".title").empty();
}
function swatchVariantHandler(e, t) {  
  var qvparent = modal_qv_parent;
  qvparent.find("#product-variant").val(t.id);
    var i = e,
        a = i.find(".price"),
        n = i.find(".add-info"),
        d = n.length && n.find(".sku"),
        o = n.length && n.find(".availability"),
        r = i.find(".input-counter").find("input"),
        l = i.find(".btn-addtocart"),
        s = i.find(".barcode"),
        c = i.find(".qty-label"),
        f = (i.find(".input-counter"), Shopify.formatMoney(t.price, money_format)),
        _ = Shopify.formatMoney(t.compare_at_price, money_format);
    t.price < t.compare_at_price ? (a.find(">span:first").addClass("new-price").html(f), a.find(">span:last").removeClass("hide").html(_)) : (a.find(">span:first").removeClass("new-price").html(f), a.find(">span:last").addClass("hide")),
        d.length && (d.children().last().html(t.sku), "" == t.sku ? d.addClass("hide") : d.removeClass("hide")),
        s.length && (s.html(t.barcode), "" == t.barcode ? s.parent().addClass("hide") : s.parent().removeClass("hide"));
    var u = t.inventory_management,
        h = t.inventory_policy,
        m = t.inventory_quantity;
    if (
        (o.length &&
            (Boolean(t.available)
                ? (o.find(".sold_out").addClass("hide"),
                  null == u || "continue" == h
                      ? ((m = 9999), o.find(".stock_quantity, .in_stock").addClass("hide"), o.find(".many_in_stock").removeClass("hide"))
                      : (o.find(".stock_quantity").removeClass("hide").html(m), o.find(".in_stock").removeClass("hide"), o.find(".many_in_stock").addClass("hide")),
                  r.val(1).attr("size", m))
                : (o.find(".stock_quantity, .in_stock, .many_in_stock").addClass("hide"), o.find(".sold_out").removeClass("hide"))),
        $("body").trigger("refreshCurrency"),
        0 == l.length)
    )
        return !1;
    Boolean(t.available) ? (c.closest(".wrapper").show(), l.html(addtocart_text).removeClass("disable")) : (c.closest(".wrapper").hide(), l.html(unavailable_text).addClass("disable"));
}
